// MODIFIED: Payroll Reason Code Modal - Added inputs for new fields
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CheckInput, Input } from "../../../../../common/Input";

const PayrollReasonCodeAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({
    description: "",
    payrollCode: "",
    fieldName: "",
    isActive: true,
  });

  useEffect(() => {
    if (selectedItem) {
      setForm({
        ...selectedItem,
      });
    } else {
      setForm({
        description: "",
        payrollCode: "",
        fieldName: "",
        isActive: true,
      });
    }
  }, [selectedItem, isOpen]);

  const handleInputChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 overflow-auto" style={{ marginTop: 0 }} >
      <div className="bg-white w-full md:w-[450px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold">{selectedItem ? "Edit" : "Add"} Reason Code</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="p-6 space-y-4">
          <Input
            label="Payroll Code"
            value={form.payrollCode}
            onChange={(e) => handleInputChange('payrollCode', e.target.value)}
            placeholder="Enter payroll code"
          />
          <Input
            label="Field Name"
            value={form.fieldName}
            onChange={(e) => handleInputChange('fieldName', e.target.value)}
            placeholder="Enter field name"
          />
          <Input
            label="Description"
            isRequired={true}
            value={form.description}
            onChange={(e) => handleInputChange('description', e.target.value)}
            placeholder="Enter reason description"
          />
          <CheckInput
            name="Active"
            value={form.isActive}
            onChange={(val) => setForm({ ...form, isActive: val })}
            isEditMode={true}
          />
        </div>

        <div className="flex justify-end space-x-2 p-5 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer">Cancel</button>
          <button
            disabled={!form.description?.trim()}
            onClick={() => onSave(form)}
            className={`px-6 py-2 text-white rounded border-none cursor-pointer ${!form.description?.trim() ? 'bg-gray-400' : 'bg-blue-600'}`}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayrollReasonCodeAddEditModal;